/**
 * @Author: maple
 * @Date: 2019-11-01 17:05:02
 * @LastEditors: maple
 * @LastEditTime: 2019-11-04 10:37:23
 */
import { createStore } from '@souche-f2e/muji';
import { fetchDocsBar } from '../services/docs-stable';

export default createStore({
  state: {
    // menuItems: [],
    selectedKeys: [],
    openKeys: [],
    // findList: [],
    groups: [],
    groupMap: {},
    isLogin: true
  },
  reducers: {
    SELECT(state, { url, groupId }) {
      if (url === '/docs') {
        return {
          ...state,
          selectedKeys: [],
          openKeys: []
        }
      }

      if(url[url.length - 1] === '/') {
        url = url.slice(0, url.length - 2);
      }

      const urlShorts = url.split('/');

      const id = urlShorts.pop();
      const idType = urlShorts.pop();

      let selectedKeys;
      let openKeys;

      if(idType === 'api') {
        selectedKeys = [ `${id}` ];
        openKeys = [ groupId ];
      } else if (idType === 'group') {
        selectedKeys = [];
        openKeys = [ id || groupId];
      } else {
        return state;
      }

      return {
        ...state,
        selectedKeys: selectedKeys,
        openKeys: openKeys
      };
    },

    UPDATE_BAR(state, { groups = [] }) {
      const subMenus = groups.map(group => ({ name: group.name, key: group.id + '' }));
      const subMenuMap = {};

      for (const group of groups) {
        subMenuMap[group.id] = group.apis.map(api => ({
          key: api.id + '',
          name: api.name,
          code: api.code,
          url: `/documents/stable_docs/api/${api.id}?groupId=${group.id}`
        }));
      }

      return {
        ...state,
        groups: subMenus,
        groupMap: subMenuMap
      }
    },
    SET_LOGIN_STATUS(state, { status = true }) {
      return {
        ...state,
        isLogin: status
      }
    }
  },
  effects: {
    async fetch() {
      const body = await fetchDocsBar().promise;

      const { success, code, msg, data } = body;
      const { apis, groups } = data;

      if (success) {
        this.UPDATE_BAR({ apis, groups });
      }

      if (success === false && code === 403 && msg === '未登录') {
        this.SET_LOGIN_STATUS({ status: false });
      } else {
        this.SET_LOGIN_STATUS({ status: true });
      }
    }
  }
});
